import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Link } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartSine } from '@awesome.me/kit-2be97ecbd6/icons/classic/solid';
import clsx from 'clsx';
import { DateTime } from 'luxon';

import BottomBar from '../components/BottomBar.jsx';
import BottomBarArea from '../components/BottomBarArea.jsx';
import RiverSiteMap from '../components/RiverSiteMap.jsx';

import 'mapbox-gl/dist/mapbox-gl.css';
import styles from './River.module.css';
import Placeholder from '../components/Placeholder.jsx';

function RiverMap({river, allData}) {
  const {t} = useTranslation();
  const navigate = useNavigate();

  function goToSite(siteId) {
    navigate(`/rivers/${river?.key}#${siteId}`);
  }

  return (
    <div className={styles.RiverPage}>
      <RiverSiteMap
        className={styles.RiverMap}
        geometry={river?.geometry}
        sites={river?.sites}
        allData={allData}
        interactive={true}
        padding={{left: 150, right: 150 , top: 80, bottom: 80}}
        goToSite={goToSite}
      />
      <div className={styles.RiverMapOverlay}>
        <h1>
          <Placeholder ready={river} xs={3}>
            {river?.name}
          </Placeholder>
        </h1>
        <div className={styles.RiverMapToolContainer}>
          <Link to={`/rivers/${river?.key}`} className={clsx('btn', 'btn-sm', 'btn-dark', styles.RiverMapHeaderButton)}>
            <FontAwesomeIcon icon={faChartSine} />
            Chart View
          </Link>
        </div>
      </div>
      <BottomBarArea sticky={false}>
        {allData?.warning && DateTime.fromISO(allData?.warning?.validity_end_timestamp) > DateTime.now() && (
          <BottomBar message={allData?.warning?.title} link={river?.warning_link} severity={'warning'} />
        )}
      </BottomBarArea>
    </div>);
}

export default RiverMap
